import useSWR, { SWRConfiguration } from "swr";
import { getNotificationCount } from "@modules/notificationService/api";
import { INotificationCountResponse } from "@modules/notificationService/interfaces/responses";

export const useGetNotificationCount = (options: SWRConfiguration = {}) =>
    useSWR<INotificationCountResponse>("useGetNotificationCount", {
        ...options,
        fetcher: getNotificationCount,
    });
